// Human-readable file size in French units (o / Ko / Mo / Go), 1024-based — ported from the mkp-frontend
// reference (`formatBytes`) and localised to match the rest of the app (e.g. "0,5 Mo"). Returns null for an
// unknown/invalid size so the caller can omit the line entirely.
export const formatBytes = (bytes: number | null | undefined): string | null => {
    if (typeof bytes !== 'number' || !Number.isFinite(bytes) || bytes < 0) return null;
    if (bytes < 1024) return `${bytes} o`;

    const units = ['Ko', 'Mo', 'Go'];
    let value = bytes / 1024;
    let unitIndex = 0;
    while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex += 1;
    }

    // One decimal of precision at every magnitude (0,5 Mo / 29,4 Mo); trailing zero dropped so exact
    // values stay clean (10 Mo, not 10,0 Mo). French comma decimal separator.
    const rounded = Math.round(value * 10) / 10;
    return `${rounded.toString().replace('.', ',')} ${units[unitIndex]}`;
};
